var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.75H7C2.59 21.75 1.25 20.41 1.25 16V8C1.25 3.59 2.59 2.25 7 2.25H17C21.41 2.25 22.75 3.59 22.75 8V16C22.75 20.41 21.41 21.75 17 21.75ZM7 3.75C3.42 3.75 2.75 4.43 2.75 8V16C2.75 19.57 3.42 20.25 7 20.25H17C20.58 20.25 21.25 19.57 21.25 16V8C21.25 4.43 20.58 3.75 17 3.75H7Z",
    fill: "#6A6077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.75H14C13.59 8.75 13.25 8.41 13.25 8C13.25 7.59 13.59 7.25 14 7.25H19C19.41 7.25 19.75 7.59 19.75 8C19.75 8.41 19.41 8.75 19 8.75Z",
    fill: "#6A6077"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.75H15C14.59 12.75 14.25 12.41 14.25 12C14.25 11.59 14.59 11.25 15 11.25H19C19.41 11.25 19.75 11.59 19.75 12C19.75 12.41 19.41 12.75 19 12.75Z",
    fill: "#6A6077"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.75H17C16.59 16.75 16.25 16.41 16.25 16C16.25 15.59 16.59 15.25 17 15.25H19C19.41 15.25 19.75 15.59 19.75 16C19.75 16.41 19.41 16.75 19 16.75Z",
    fill: "#6A6077"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.04C7.09 12.04 5.94 10.89 5.94 9.48C5.94 8.07 7.09 6.92 8.5 6.92C9.91 6.92 11.06 8.07 11.06 9.48C11.06 10.89 9.91 12.04 8.5 12.04ZM8.5 8.42C7.92 8.42 7.44 8.9 7.44 9.48C7.44 10.06 7.92 10.54 8.5 10.54C9.08 10.54 9.56 10.06 9.56 9.48C9.56 8.9 9.08 8.42 8.5 8.42Z",
    fill: "#6A6077"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.08C11.62 17.08 11.29 16.79 11.25 16.4C11.14 15.32 10.27 14.45 9.18 14.35C8.72 14.31 8.26 14.31 7.8 14.35C6.71 14.45 5.84 15.31 5.73 16.4C5.69 16.81 5.32 17.12 4.91 17.07C4.5 17.03 4.2 16.66 4.24 16.25C4.42 14.45 5.85 13.02 7.66 12.86C8.21 12.81 8.77 12.81 9.32 12.86C11.12 13.03 12.56 14.46 12.74 16.25C12.78 16.66 12.48 17.03 12.07 17.07C12.05 17.08 12.02 17.08 12 17.08Z",
    fill: "#6A6077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c6d701752ffe17dfc89b7f7d30ae2951.svg";
export { ForwardRef as ReactComponent };